import _ from "lodash";
import React from "react";
import { useSelector } from "react-redux";

import { getHelpContent } from "../../../store/help/help.reducer";
import { HelpSection } from "./HelpSection";

import "./HelpContent.scss";

export const HelpContent = () => {
  const helpSections = useSelector(getHelpContent);

  return (
    <div className="help-content">
      {_.map(helpSections, (section) => (
        <HelpSection key={section.id} section={section} />
      ))}
    </div>
  );
};
